import {gql} from "@apollo/client";
import universityFragment from "../fragments/universityFragment";

const GetUniversityQuery = gql`
    query GetUniversityQuery($slug: String) {
        university(slug: $slug) {
            ...UniversityFull
            customAttributes(destination: "applicant_profile", active: true) {
                id
                type
                name
                active
                required
                options {
                    id
                    value
                }
            }
        }
    }
    ${universityFragment}
`;

export default GetUniversityQuery;
